import { html, LitElement } from 'lit';
import fsTypography from '@cof/fs-typography-core/lib/typography.lit.min.js';
import { displayProgressBarEvent } from '@cof/refi-web-sdk/dist/utils/update-progress-bar';
import { DebugService } from '../../shared/services/debug.service.js';
import { style } from './contract-error.style.js';
import { pageHeaders } from '../../shared/styles/page-headers.style.js';
import { REFI_ESIGN_CONST } from '../../../constants/app.constants.js';

class RefiContractError extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiContractError');
  }

  static get properties() {
    return {
      message: { attribute: true },
      isSubmitFailure: { type: Boolean },
    };
  }

  static get styles() {
    return [pageHeaders, style, fsTypography];
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.isSubmitFailure) {
      displayProgressBarEvent(false);
    }
  }

  render() {
    this.debug.log('Contract Error Page');
    if (this.isSubmitFailure) {
      return html` <refi-track-pageview pagename="esign-error"></refi-track-pageview>
        <div class="medium-spacer"></div>
        <div class="refi-contract-error-ui">
          <h1 class="error-text fs-text fs-text-weight--semibold fs-text-size--medium-3">We were unable to save your e-signature</h1>
          <div class="medium-spacer"></div>
          <p class="error-text fs-text fs-text-size--medium-1">We experienced a system error. Please call us at 1.888.263.4582.</p>
          <div class="large-spacer"></div>
          <strong class="error-text fs-text fs-text-weight--semibold fs-text-size--medium-1">Your credit application was approved. We will not conduct another hard credit pull.</strong>
        </div>
        <div class="large-spacer"></div>`;
    }

    return html`
      <refi-track-pageview pagename="esign-error"></refi-track-pageview>
      <div class="refi-contract-error-ui">
        <img class="error-img" src="${REFI_ESIGN_CONST.ASSETS_URL}/iconic-error.svg" alt="contract error" />
        <div class="bau-error-text"><p>Unfortunately, the contract could not be generated. Please try again or call us at 1.888.263.4582.</p></div>
      </div>
    `;
  }
}

customElements.define('refi-contract-error', RefiContractError);
